import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import { AbTitle } from '../../../ui';
import { type Colors } from '../../../../types';

interface Props {
  name?: string;
  description?: string;
  color?: Colors;
  image?: string;
  alt?: string;
  position?: number;
  modelsCount?: number | string;
  modelsCountText?: string;
  small?: boolean;
  customModelsCount?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionCategoriesCard',
  props: {
    name: { default: 'Banner title' },
    description: { default: 'Banner description' },
    color: { default: 'gray' },
    image: { default: '/img/watches.png' },
    alt: null,
    position: { default: 1 },
    modelsCount: { default: 0 },
    modelsCountText: null,
    small: { type: Boolean, default: false },
    customModelsCount: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,CdnImg, AbTitle }
}

})